import { render } from "./ApiClientForm.vue?vue&type=template&id=33365912&scoped=true"
import script from "./ApiClientForm.vue?vue&type=script&lang=js"
export * from "./ApiClientForm.vue?vue&type=script&lang=js"

import "./ApiClientForm.vue?vue&type=style&index=0&id=33365912&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33365912"]])

export default __exports__